// extracted by mini-css-extract-plugin
export default {"card":"Team-Card_card__d0vRK","img":"Team-Card_img__RYQl2","text":"Team-Card_text__zLDL0","link":"Team-Card_link__spgem","dark":"Team-Card_dark__BVC0P"};